import home from './views/home/home.vue'
// import team from './views/team/team.vue'
// import designsystem from './views/design-system/design-system.vue'
import pushtester from './views/pushtester/pushtester.vue'
import banner from './views/banner/banner.vue'

export default [
    // {
    //     name: 'team',
    //     path: '/team',
    //     component: team
    // },
    // {
    //     name: 'design-system',
    //     path: '/design-system',
    //     component: designsystem,
    // },
    {
        name: 'pushtester',
        path: '/pushtester',
        component: pushtester
    },
    {
        name: 'banner',
        path: '/banner',
        component: banner
    },
    {
        name: 'home',
        path: '/',
        component: home
    },
]